<template>
  <label class="ui-form-item">
    <span class="ui-form-item__label" v-if="label">{{ label }}</span>
    <span class="ui-form-item__block">
      <slot></slot>
    </span>
  </label>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'FormItem',
  props: {
    label: String as PropType<string>,
  },
})
</script>

<style lang="stylus">
.ui-form-item
  margin-bottom 20px
  display block
  &__label
    display block
    margin-bottom .4rem
  &__block
    display block
    input
    textarea
    select
      font-size .9rem
      font-weight 400
      line-height 1.5
      display block
      width 100%
      height calc(2.1rem + 2px)
      padding .375rem .75rem
      transition border-color .15s ease-in-out, box-shadow .15s ease-in-out
      color var(--dark-font-color)
      border 1px solid var(--border-gray-color)
      border-radius .25rem
      background-color #fff
      background-clip padding-box
      &:focus
        outline 0
        border-color var(--secondary-color)
  &:last-child
    margin-bottom 0
</style>
